// Import api models.
import {
    EndorsementPolicyTypeAndId,
    EndorsementRequestCommercial,
    EndorsementRequestPersonal,
    EndorsementResponse,
    EndorsementResponseCostValues,
    PossiblePeril
} from '@app/models/api';
// Import controller interfaces.
import { IEndorsementController } from '../Interfaces/ControllerInterfacesBarrel';

export default class MockEndorsementController implements IEndorsementController {

    public constructor() {

    }

    public async createEndorsement(policyId: number): Promise<number> {
        throw new Error('Method not implemented.');
    }

    public async getEndorsementPolicyTypeAndId(endorsementId: number): Promise<EndorsementPolicyTypeAndId> {
        throw new Error('Method not implemented.');
    }

    // #region personal-lines

    public async getEndorsementValuesPersonal(endorsementId: number): Promise<EndorsementResponse> {
        throw new Error('Method not implemented.');
    }

    public async updateEndorsementPersonal(endorsementId: number, endorsement?: EndorsementRequestPersonal, endorsementDate?: Date): Promise<boolean> {
        throw new Error('Method not implemented.');
    }

    // #endregion personal-lines

    // #region commercial-lines

    public async getEndorsementValuesCommercial(endorsementId: number): Promise<EndorsementResponse> {
        throw new Error('Method not implemented.');
    }

    public async updateEndorsementCommercial(endorsementId: number, endorsement?: EndorsementRequestCommercial, endorsementDate?: Date): Promise<boolean> {
        throw new Error('Method not implemented.');
    }

    // #endregion commercial-lines

    // #region calculation

    public async calculateEndorsement(endorsementId: number): Promise<EndorsementResponseCostValues> {
        throw new Error('Method not implemented.');
    }

    // #endregion calculation

    // #region perils and deductibles

    public async getPossiblePerilsAndDeductibles(endorsementId: number, endorsementDate?: Date): Promise<PossiblePeril[]> {
        throw new Error('Method not implemented.');
    }

    // #endregion perils and deductibles.
}
